import React from 'react';
import { ClassAssembly6D2025 } from '../views';


const ClassAssemblyPage = () => {
    return <ClassAssembly6D2025/>;
  };
  
  export default ClassAssemblyPage;